import { render, staticRenderFns } from "./DeliveryStep.vue?vue&type=template&id=3dc2704c&scoped=true&"
import script from "./DeliveryStep.vue?vue&type=script&lang=js&"
export * from "./DeliveryStep.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStep.vue?vue&type=style&index=0&id=3dc2704c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc2704c",
  null
  
)

export default component.exports